export enum CHANNEL {
  STUDENT_LIST = 'STUDENT_LIST',
  STUDENT = 'STUDENT'
}

export enum TOPIC {
  OPEN_STUDENT = 'OPEN_STUDENT',
  CALENDLY_INTERVIEWS = 'CALENDLY_INTERVIEWS',
  RECORDED_INTERVIEWS = 'RECORDED_INTERVIEWS',
  MESSAGES = 'MESSAGES',
  STUDENT_CORE = 'STUDENT_CORE',
  STUDENT_DETAILS = 'STUDENT_DETAILS',
  STUDENT_HISTORY = 'STUDENT_HISTORY',
  STUDENT_FINANCE = 'STUDENT_FINANCE',
  STUDENT_SUMMARY = 'STUDENT_SUMMARY',
  CALENDLY_INTERVIEW_DOCS = 'CALENDLY_INTERVIEW_DOCS',
  RECORDED_INTERVIEW_DOCS = 'RECORDED_INTERVIEW_DOCS',
  DOCUMENTS = 'DOCUMENTS',
  FINANACE_DOCUMENTS = 'FINANACE_DOCUMENTS',
  FOLLOW_UP_DOCUMENTS = 'FOLLOW_UP_DOCUMENTS'
}

export interface IWebsocketMessage {
  action?: string;
  channel: CHANNEL;
  view: string; // UNI#INTAKE_ID
  subject?: string;
}

export interface IWebsocketServerMessage extends IWebsocketMessage {
  topic: TOPIC;
  data: string;
}
export interface IWebsocketMessageSubscription extends IWebsocketMessage {
  topic: Array<TOPIC>;
}

export enum TYPE {
  RECEIVED = 'RECEIVED',
  SENT = 'SENT'
}

export interface ISubscription {
  key: string;
  handler: (message: unknown) => void;
}
